
/*
 *   File : activate-ddpi-modal.js
 *   Author URI : https://evoqins.com
 *   Description : Non-POA/DDPI overlay for Demat redemption — prompts user to activate DDPI or go back
 *   Integrations : FundRedeemModal
 *   Version : v1.0
 */
import { useEffect } from "react";

import Icon from "../Icon/icon";
// import { GradientButton, OutlineButton } from "../CTA";
import style from "../../Styles/Components/activate-ddpi-modal.module.scss";
import { GradientButton, OutlineButton } from "../Cta";

/**
 * @param {boolean} show — when true, modal is mounted and shown by parent
 * @param {function} onBack — close overlay / stay on redeem form
 * @param {function} onActivateDDPI — e.g. navigate to profile and close parent modal
 */
const ActivateDDPIModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("activate-ddpi-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);


    return (
        <div className={`modal fade `}
            id="activate-ddpi-modal"
            tabIndex="-1"
            aria-labelledby="ddpi-poa-title"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className={`modal-content ${style.e_ddpi_card} bg-modal border-radius-24px position-relative`}>
                    <span id="close-activate-ddpi-modal" data-bs-dismiss="modal" className="d-none"></span>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_ddpi_close}`} />

                    <div className={style.e_ddpi_icon_wrap}>
                        <div className={style.e_ddpi_icon_ring}>
                            <span className={style.e_ddpi_icon_inner}>i</span>
                        </div>
                    </div>

                    <p id="ddpi-poa-title"
                        className="color-eerie-black e-poppins-medium e-font-14 line-height-22px text-center mb-0 px-2">
                        {props.content}
                    </p>

                    <div className={`d-flex align-items-stretch gap-3 justify-content-center margin-24px-top ${style.e_ddpi_actions}`}>
                        {/* <OutlineButton label="Back"
                            disabled={false}
                            cancel="modal"
                            className={`flex-fill border-radius-8px e-font-16 padding-12px-tb`}
                            handleClick={onBack} /> */}
                        <GradientButton label="understood"
                            disabled={false}
                            cancel="modal"
                            className="flex-fill e-font-16 padding-12px-tb border-radius-8px"
                            handleClick={() => { }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivateDDPIModal;
